import { useCallback } from 'react';

import useAnalytics from '@/components/Analytics/hooks/useAnalytics';
import { MeetingTypeEnum } from '@/types/schema';

const MeetingsEvents = {
  onAgendaDeleted: 'Agenda deleted',
  onPastAgendaMovedToCurrent: 'Past agenda moved to current',
  onDocAttachedInAgenda: 'Doc attached in agenda',
  onOKRAddedInAgenda: 'OKR added in agenda',
  onTaskAddedInAgenda: 'Task added in agenda',
  onAgendaCategoryChanged: 'Agenda category changed',
  onAgendaAdded: 'Agenda added',
};

const TMEvents = {
  onOneOffTMStartedInstantly: 'one off meeting started instantly',
  onOneOffTMScheduled: 'one off meeting scheduled for later',
  onOKRAddedToTM: 'OKR added to meeting',
  onKeyDocAddedToTM: 'Key doc added to meeting',
  onScheduleTM: 'new meeting created',
  onSetupTMModalOpened: 'Setup meeting modal opened',
};

const OneOnOneEvents = {
  onOneOff1on1StartedInstantly: 'one off 1:1 started instantly',
  onOneOff1on1Scheduled: 'one off 1:1 scheduled for later',
  onDeactivate1on1: 'Deactivate 1:1',
  onSchedule1on1: '1:1 Scheduled',
  onSetup1on1ModalOpened: 'Setup 1:1 modal opened',
} as const;

const OneOnOneMeta = { module: '1:1s' };
const MeetingsMeta = { module: 'Meetings' };

const getMeta = (type: MeetingTypeEnum) => {
  if (type === MeetingTypeEnum.OneOnOne) {
    return OneOnOneMeta;
  }
  return MeetingsMeta;
};

const useMeetingEvents = () => {
  const { track } = useAnalytics();

  const onTrackMeetingEvent = useCallback(
    (event: keyof typeof MeetingsEvents, meetingType?: MeetingTypeEnum) => {
      if (!meetingType) return;
      track(MeetingsEvents[event], getMeta(meetingType));
    },
    [track],
  );

  const onTrackOneOnOneEvent = useCallback(
    (event: keyof typeof OneOnOneEvents) => {
      track(OneOnOneEvents[event], OneOnOneMeta);
    },
    [track],
  );

  const onTrackTMEvent = useCallback(
    (event: keyof typeof TMEvents) => {
      track(TMEvents[event], MeetingsMeta);
    },
    [track],
  );

  return {
    onTrackMeetingEvent,
    onTrackOneOnOneEvent,
    onTrackTMEvent,
  };
};

export default useMeetingEvents;
